import { ProfilePageLayout } from '../../containers/profile/layouts/ProfilePageLayout'
import { getProfileServerSideProps } from '../../containers/profile/layouts/profileServerSideProps'
import { OverviewSection } from 'containers/profile-overview'

const ProfilePage = () => {
  return <OverviewSection />
}

export default ProfilePage

export const getServerSideProps = getProfileServerSideProps

ProfilePage.getLayout = ProfilePageLayout
